export default "__VITE_ASSET__BfIDXeUL__"